import { BaseTenantLinksDto } from '../../shared/dtos/base-tenant-links.dto';

/**
 * Rental agreement links DTO
 */
export class RentalAgreementLinksDto extends BaseTenantLinksDto {
	vehicleCategoryId?: number | null;
}
